import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import CustomTable  from '../../components/tables/customTable'
import { useDocumentTitle } from '../../components/useDocumentTitle';

import {
    debouncedGetJobs,
    debouncedDeleteJob,
    debouncedGetChooseJob,
    debouncedGetVehicleMakes,
    debouncedGetColorList,
    resetOpenJob,
    setIsNewJob,
    debouncedGetJobVehicleImgs
} from '../../store/job/actions'
import { dateFormat } from '../../helpers/stringFormat'
import ExpandedCard from '../../components/modals/ExpandedCard';
import { initializePusher, unbindPusher } from '../../pusherManager';
import { getCookie } from '../../helpers/globals';
import Loader from '../../components/Loader';

const JobList = (props) => {
    const history = useHistory();
    const location = useLocation();

    useDocumentTitle("Helios - Job List")
    const [selectedJob, setSelectedJob] = useState({});
    const [pulseAnimation, setPulseAnimation] = useState(false)
    const [archivedJob, setArchivedJob] = useState(false);
    const params = new URLSearchParams(location.search);
    const jobId = params.get('jobId');
    const [search, setSearch] = useState(localStorage?.getItem("search_job") ?? "")
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            title: 'RO Number',
            fixed: 'left',
            align: 'left',
            sorter: (a, b) => (a.ro_number || "").localeCompare(b.ro_number || ""),
            render: record => <span>{record.ro_number}</span>
        },
        {
            title: 'Customer',
            align: 'left',
            sorter: (a, b) => (a.customer.firstname || "").localeCompare(b.customer.firstname || ""),
            render: record => (
                <a className="table_anchor">
                    {record.customer && record.customer.firstname + ' ' + record.customer.lastname}
                </a>
            ),
        },
        {
            title: 'Vehicle',
            align: 'left',
            render: record => (
                <span>
                    {record.vehicle &&
                        `${record.vehicle?.year} ${record.vehicle?.make?.name} ${record.vehicle.model} ${record.vehicle?.vehicle_color ? record.vehicle?.vehicle_color : ''}`
                    }
                </span>
            ),
        },
        {
            title: 'Status',
            align: 'left',
            sorter: (a, b) => (a.plan_date || "").localeCompare(b.plan_date || ""),
            render: record => (
                <span>
                    {record.status_from_organization == null ? 
                        (record.plan_date == null ? 'Unscheduled' : 'Scheduled') 
                        : record.status_from_organization.name}
                </span>
            ),
        },
        {
            title: 'Assigned To',
            align: 'left',
            sorter: (a, b) => (a.assigned_to_user && a.assigned_to_user.firstname || "").localeCompare(b.assigned_to_user && b.assigned_to_user.firstname || ""),
            render: record => (
                <span>
                    {record.assigned_to_user ? record.assigned_to_user.firstname : ''} {record.assigned_to_user ? record.assigned_to_user.lastname : ''}
                </span>
            ),
        },
        {
            title: 'Last updated',
            dataIndex: 'updated_at',
            align: 'left',
            sorter: (a, b) => (a.updated_at || "").localeCompare(b.updated_at || ""),
            render: date => dateFormat(date, 'TXT_YEAR_DATE')
        }
    ];


    useEffect(() => {
        props.debouncedGetVehicleMakes()
        props.debouncedGetColorList()
    }, [])

    useEffect(() => {
        if (props?.jobs?.data?.length > 0 && jobId)
            handleJobCardClick()
    }, [props?.jobs?.data?.length, jobId])


    const changeBackground = (color) => {
        setSelectedJob({ ...selectedJob, color_id: color?.id, job_color: color })
    }

    const onArchiveJob = (status) => {
        // status - 0: archive, 1: unarchive
        if (status == 0) {
            setArchivedJob(true)
        } else if (status == 1) {
            setPulseAnimation(false)
            setArchivedJob(false)
            setTimeout(() => {
                setPulseAnimation(false)
            }, 5000)
        }
    }

    const handleJobCardClick = async () => {
        let card = await document.querySelector('#job_' + jobId);
        if (card) {
            card.click();
        }
    };

    return (
        <div className="job-list">
            <Loader loading={props.jobs.loading || loading} />
            <CustomTable
                columns={columns}
                searchBy='customer'
                hideActionColumn={true}
                data={props?.jobs?.data?.sort((a, b) => a.customer.lastname.localeCompare(b.customer.lastname))}
                getData={(params) => props.debouncedGetJobs(params, true)}
                deleteRecord={(id) => props.debouncedDeleteJob(id)}
                debouncedGetJobVehicleImgs={(id) => props.debouncedGetJobVehicleImgs(id)}
                route="/job"
                refreshTable={(params) => props.debouncedGetJobs(params, true)}
                loading={props.jobs.loading}
                onOpenJob={(item) => {
                    props.debouncedGetChooseJob(item.id, true)
                    setSelectedJob(item)
                    const queryParams = '?jobId=' + item.id;
                    window.history.pushState({}, '', `#${history.location.pathname}${queryParams}`);
                }}
                setIsNewJob={props.setIsNewJob}
                isNewJob={props.isNewJob}
                jobs={props?.jobs}
                clearOpenJob={() => {
                    if (Object?.keys(props?.newJob?.data)?.length > 0)
                        props.resetOpenJob()
                }}
                setLoading={setLoading}
            />
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        jobs: state.JobReducer.jobs,
        newJob: state.JobReducer.newJob,
        colorList: state.JobReducer.colorList,
        isNewJob: state.JobReducer.isNewJob
    }
}

const mapDispachToProps = (dispatch) => ({
    debouncedGetJobs: (offset, loading) => debouncedGetJobs(dispatch, offset, loading),
    debouncedDeleteJob: (id) => debouncedDeleteJob(dispatch, id),
    debouncedGetChooseJob: (id, loading) => debouncedGetChooseJob(dispatch, id, loading),
    debouncedGetVehicleMakes: () => debouncedGetVehicleMakes(dispatch),
    debouncedGetColorList: () => debouncedGetColorList(dispatch),
    resetOpenJob: () => dispatch(resetOpenJob()),
    setIsNewJob: (isNew) => dispatch(setIsNewJob(isNew)),
    debouncedGetJobVehicleImgs: (id) => debouncedGetJobVehicleImgs(dispatch, id)

})

export default connect(mapStateToProps, mapDispachToProps)(JobList)